// 시중교재의 정답 지원 여부. 서버는 다른 교재 종류에도 answerConfirmed 를 내려주고 true·false·null 셋이 온다.
// false 일 때만 정답 미지원이다. true 와 null 은 정답 지원으로 읽는다.
export const normalizeAnswerConfirmed = (answerConfirmed: unknown): boolean =>
  answerConfirmed !== false
